import { render } from "./Proxy.vue?vue&type=template&id=c3270c46&scoped=true"
import script from "./Proxy.vue?vue&type=script&lang=js"
export * from "./Proxy.vue?vue&type=script&lang=js"

import "./Proxy.vue?vue&type=style&index=0&id=c3270c46&scoped=true&lang=css"

import exportComponent from "/build/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3270c46"]])

export default __exports__